/* Herbal Shampoo Product Template — herbal-shampoo.js */
(function() {
  'use strict';

  function initGallery() {
    var main = document.getElementById('hs-gallery-main');
    var thumbStrip = document.getElementById('hs-gallery-thumbs');
    var thumbs = document.querySelectorAll('.hs-gallery__thumb');
    var prevBtn = document.querySelector('.hs-gallery__arrow--prev');
    var nextBtn = document.querySelector('.hs-gallery__arrow--next');
    var thumbPrevBtn = document.querySelector('.hs-thumb-arrow--prev');
    var thumbNextBtn = document.querySelector('.hs-thumb-arrow--next');
    if (!main) return;

    var currentIndex = 0;
    var THUMB_SCROLL = 82; // 72px thumb + 10px gap

    function updateMainImage(index) {
      var thumb = thumbs[index];
      if (!thumb) return;
      var img = thumb.querySelector('img');
      var mainImg = main.querySelector('img');
      if (!mainImg) return;
      var fullSrc = thumb.dataset.fullSrc || (img && img.src) || '';
      mainImg.src = fullSrc;
      mainImg.srcset = '';
      mainImg.alt = (img && img.alt) || '';
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      // Scroll active thumb into view
      if (thumbStrip) {
        var thumbLeft = thumb.offsetLeft;
        var stripWidth = thumbStrip.offsetWidth;
        var thumbWidth = thumb.offsetWidth;
        if (thumbLeft < thumbStrip.scrollLeft) {
          thumbStrip.scrollTo({ left: thumbLeft - 4, behavior: 'smooth' });
        } else if (thumbLeft + thumbWidth > thumbStrip.scrollLeft + stripWidth) {
          thumbStrip.scrollTo({ left: thumbLeft + thumbWidth - stripWidth + 4, behavior: 'smooth' });
        }
      }
    }

    function goTo(index) {
      if (!thumbs.length) return;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;
      updateMainImage(currentIndex);
    }

    // Thumbnail clicks
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goTo(i); });
    });

    // Main image arrows
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    // Thumbnail strip arrows
    if (thumbPrevBtn) thumbPrevBtn.addEventListener('click', function() {
      if (thumbStrip) thumbStrip.scrollBy({ left: -THUMB_SCROLL * 3, behavior: 'smooth' });
    });
    if (thumbNextBtn) thumbNextBtn.addEventListener('click', function() {
      if (thumbStrip) thumbStrip.scrollBy({ left: THUMB_SCROLL * 3, behavior: 'smooth' });
    });

    // Hide main arrows if only 1 image
    if (thumbs.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (thumbPrevBtn) thumbPrevBtn.style.display = 'none';
      if (thumbNextBtn) thumbNextBtn.style.display = 'none';
    }

    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  function initQty() {
    var btns = document.querySelectorAll('[data-hs-qty]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = btn.dataset.hsQty;
        var display = btn.parentElement.querySelector('[data-hs-qty-num]');
        var input = document.querySelector('[name="quantity"]');
        if (!display) return;
        var val = parseInt(display.textContent) || 1;
        if (action === 'minus') val = Math.max(1, val - 1);
        if (action === 'plus') val = Math.min(99, val + 1);
        display.textContent = val;
        if (input) input.value = val;
      });
    });
  }

  function initFaq() {
    var items = document.querySelectorAll('.hs-faq__item');
    items.forEach(function(item) {
      var toggle = item.querySelector('.hs-faq__toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function() {
        var isOpen = item.classList.contains('open');
        items.forEach(function(it) { it.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('.hs-sticky');
    if (!sticky) return;
    function onScroll() {
      var sy = window.scrollY || window.pageYOffset;
      sticky.classList.toggle('visible', sy > 720);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function showToast(msg) {
    var toast = document.querySelector('.hs-toast');
    if (!toast) return;
    toast.textContent = msg || 'Added to cart!';
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2200);
  }

  function getVariantId() {
    var form = document.getElementById('hs-product-form');
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) return idInput.value;
    }
    return null;
  }

  function getQty() {
    var qtyEl = document.querySelector('[data-hs-qty-num]');
    return qtyEl ? (parseInt(qtyEl.textContent) || 1) : 1;
  }

  function buyNow() {
    var variantId = getVariantId();
    var qty = getQty();
    if (!variantId) { window.location.href = '/checkout'; return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function() { window.location.href = '/checkout'; })
    .catch(function() { window.location.href = '/checkout'; });
  }

  function initCartButtons() {
    var form = document.getElementById('hs-product-form');
    if (form) {
      var addBtn = form.querySelector('[data-hs-action="add"]');
      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var formData = new FormData(form);
          formData.set('quantity', getQty());
          addBtn.textContent = 'Adding...';
          addBtn.disabled = true;
          fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(function(r) { return r.json(); })
            .then(function() {
              showToast('\u2713 Added to cart!');
              addBtn.textContent = 'Add to Cart';
              addBtn.disabled = false;
            })
            .catch(function() {
              showToast('Could not add to cart.');
              addBtn.textContent = 'Add to Cart';
              addBtn.disabled = false;
            });
        });
      }
      var stickyAdd = document.querySelector('.hs-sticky__btn-add');
      if (stickyAdd && addBtn) { stickyAdd.addEventListener('click', function() { addBtn.click(); }); }
    }
    var buyBtns = document.querySelectorAll('[data-hs-action="buy"]');
    buyBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        buyNow();
      });
    });
  }

  function init() { initGallery(); initQty(); initFaq(); initSticky(); initCartButtons(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
